export const toArray = (prop: string | string[] | undefined) => {
	if (!prop) {
		return []
	}
	if (Array.isArray(prop)) {
		return prop
	}
	return [prop]
}
